export const LOANS_CONTAINER_TAG_NAME = 'loans-container';
